import React, { Component } from 'react'
import uniqid from 'uniqid'
import Select from 'react-select'
import { fromJS, updateIn, update } from 'immutable'

// import FamilyPartnersTwinModal from './family-partners-twin-modal'
// import FamilyPartnersAdoptedModal from './family-partners-adopted-modal'


import FamilyTreeUncleAunt from './uncle-aunt'

class FamilyTreeProbandUnclesAunts extends Component {

  render() {

    let depth_label = " ";

    if(this.props.level) {
      if(this.props.level === 2) {
        depth_label = " Grand"
      } else if (this.props.level === 3) {
        depth_label = " Great Grand";
      } else if (this.props.level > 3) {
        depth_label = " ";
        for(let i = 3; i < this.props.level + 1; i++) depth_label += "Gr "
        depth_label += "Grand"
      }
    }

    for(let u_a of this.props.uncles_aunts) {
      u_a.gender = (u_a.gender == null) ? 'u' : u_a.gender
    }

    return <React.Fragment>

      {
        this.props.uncles_aunts.filter(i => i.gender.toLowerCase() == 'm' && i.half == true).map((uncle_aunt, index) => {
          return <FamilyTreeUncleAunt
            key={uncle_aunt.rkey}
            parent_side={this.props.parent_side}
            collapsed={true}
            label={this.props.parent_side + depth_label + 'Half-Uncle #' + (index + 1)}
            level={this.props.level}
            uncle_aunt={uncle_aunt}
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

      {
        this.props.uncles_aunts.filter(i => i.gender.toLowerCase() == 'f' && i.half == true).map((uncle_aunt, index) => {
          return <FamilyTreeUncleAunt
            key={uncle_aunt.rkey}
            parent_side={this.props.parent_side}
            collapsed={true}
            label={this.props.parent_side + depth_label + 'Half-Aunt #' + (index + 1)}
            level={this.props.level}
            uncle_aunt={uncle_aunt}
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

      {
        this.props.uncles_aunts.filter(i => i.gender.toLowerCase() == 'u' && i.half == true).map((uncle_aunt, index) => {
          return <FamilyTreeUncleAunt
            key={uncle_aunt.rkey}
            parent_side={this.props.parent_side}
            collapsed={true}
            label={this.props.parent_side + depth_label + 'Half-Aunt/Uncle #' + (index + 1)}
            level={this.props.level}
            uncle_aunt={uncle_aunt}
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

      {
        this.props.uncles_aunts.filter(i => i.gender.toLowerCase() == 'm' && i.half == false).map((uncle_aunt, index) => {
          return <FamilyTreeUncleAunt
            key={uncle_aunt.rkey}
            parent_side = {this.props.parent_side}
            collapsed={true}
            label={this.props.parent_side + depth_label + 'Uncle #' + (index + 1) }
            level={this.props.level}
            uncle_aunt={uncle_aunt}
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

      {
        this.props.uncles_aunts.filter(i => i.gender.toLowerCase() == 'f' && i.half == false).map((uncle_aunt, index) => {
          return <FamilyTreeUncleAunt
            key={uncle_aunt.rkey}
            parent_side = {this.props.parent_side}
            collapsed={true}
            label={this.props.parent_side + depth_label + 'Aunt #' + (index + 1) }
            level={this.props.level}
            uncle_aunt={uncle_aunt}
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

      {
        this.props.uncles_aunts.filter(i => i.gender.toLowerCase() == 'u' && i.half == false).map((uncle_aunt, index) => {
          return <FamilyTreeUncleAunt
            key={uncle_aunt.rkey}
            parent_side = {this.props.parent_side}
            collapsed={true}
            label={this.props.parent_side + depth_label + 'Aunt/Uncle #' + (index + 1) }
            level={this.props.level}
            uncle_aunt={uncle_aunt}
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

    </React.Fragment>

  }
}


export default FamilyTreeProbandUnclesAunts
